export default [
  {
    path: "/platformConfigurations/individualActivites",
    component: () => import(/* webpackChunkName: "layout" */ "../layout"),

    children: [
      {
        path: ":id",
        props: true,
        name: "platform.individualActivites.show",
        component: () =>
          import(/* webpackChunkName: "platform.individualActivites" */ "./show.vue"),
      },
    ],
  },
];
